import { useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { BsCloudDownload } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { CgSpinner } from "react-icons/cg";
import PaymentPopup from "./paymentpopup";
import Paymentpdf from "./PaymentPdf";
import useServerPagination from "../../../../hooks/useServerPagination";
import PaginationControls from "../../../../components/SmartDataTable/PaginationControls";
import SearchFilter from "../../../../components/SmartDataTable/SearchFilter";



const titles = [
  "S.NO", "VRF REFERENCE NO", "VISA BLOCK NUMBER", "VISA PROVIDER",
  "AJEER", "SPONSOR ID", "NATIONALITY", "STAMP CITY",
  "VISA PROFESSION", "PRIORITY OF ISSUANCE", "TOTAL VISAS", "STATUS", "ACTION",
];

const NAV_BASE = "p-2 px-4 rounded-md text-white text-sm font-medium";
const NAV_ACTIVE = { backgroundColor: "#1f2937" };
const NAV_INACTIVE = { backgroundColor: "#ef4444" };
const navLink = (isActive) => ({ className: NAV_BASE, style: isActive ? NAV_ACTIVE : NAV_INACTIVE });

export default function VrrPayment({ titles = [] }) {
  const location = useLocation();
  const token = useMemo(() => localStorage.getItem("nodeToken"), []);
  const [searchTerm, setSearchTerm] = useState("");
  const [showPromptElement, setShowPromptElement] = useState(false);
  const [propData, setPropData] = useState();
  const [popUpState, setPopUpState] = useState(false);
  const [popUpData, setPopUpData] = useState();

  const { data, paginationState, goToPage, changePageSize } = useServerPagination({
    apiEndpoint: "/dashboard/vrf-visa",
    token,
    defaultPageSize: 50,
    searchTerm,
    searchDebounceMs: 300,
  });

  return (
    <div className="p-2 uppercase">

      {/* Toolbar */}
      <div className="flex-wrap gap-2 w-full items-center flex flex-row-reverse mb-4">
        <SearchFilter
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          placeholder="Search across all columns..."
          isLoading={paginationState.isLoading && searchTerm.length > 0}
        />
        <span {...navLink(true)}>REQUEST</span>
        <Link to="/dashboard/Visa-return-request/Finance-desk" {...navLink(location.pathname.includes("Finance-desk"))}>RETURNS</Link>
      </div>

      {/* Scrollable Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow max-h-[70vh]">
        <table className="min-w-full">
          <thead className="sticky top-0 z-20 bg-white border-b border-slate-200">
            <tr>
              {titles.map((t, i) => (
                <th key={i} className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider">
                  {t}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {paginationState.isLoading ? (
              <tr>
                <td colSpan={titles.length} className="px-6 py-8 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <CgSpinner className="animate-spin text-xl text-blue-500" />
                    <span>Loading data...</span>
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={titles.length} className="px-6 py-8 text-center text-gray-400">
                  {searchTerm ? `No results found for "${searchTerm}"` : "No Data Found"}
                </td>
              </tr>
            ) : (
              data.map((listItem, index) => (
                <tr key={listItem.id || index} className="hover:bg-gray-50">
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{(paginationState.currentPage - 1) * paginationState.pageSize + index + 1}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.vrf_reference_number}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.visa_block_number || "------"}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.company_name}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.ajeer}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.sponsor_id}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.Nationality}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.visa_stamp_city}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.visa_profession}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.priority_of_issuance}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.total_visa}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{listItem?.status === "REFUND INITIATED" ? "REFUND" : listItem?.status}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex gap-2 items-center">
                      <button
                        className="rounded-md bg-white border border-gray-400 flex items-center justify-center"
                        style={{ width: "2rem", height: "2rem", cursor: listItem.status === "PENDING PAYMENT" || listItem.status === "REFUND INITIATED" ? "pointer" : "default" }}
                        disabled={listItem.status !== "PENDING PAYMENT" && listItem.status !== "REFUND INITIATED"}
                        onClick={() => { setShowPromptElement(true); setPropData(listItem); }}
                      >
                        <CiEdit size={"1rem"} />
                      </button>
                      <button
                        className="rounded-md bg-white border border-gray-400 flex items-center justify-center"
                        style={{ width: "2rem", height: "2rem", cursor: "pointer" }}
                        onClick={() => { setPopUpState(true); setPopUpData(listItem); }}
                      >
                        <BsCloudDownload size={"1rem"} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Footer */}
      <div className="mt-2">
        <PaginationControls
          currentPage={paginationState.currentPage}
          totalPages={paginationState.totalPages}
          pageSize={paginationState.pageSize}
          totalRecords={paginationState.totalRecords}
          onPageChange={goToPage}
          onPageSizeChange={changePageSize}
          isLoading={paginationState.isLoading}
        />
      </div>

      {showPromptElement && <PaymentPopup setShowPromptElement={setShowPromptElement} showPromptElement={showPromptElement} propData={propData} />}
      {popUpState && <Paymentpdf setPopUpState={setPopUpState} popUpState={popUpState} listItem={popUpData} />}
    </div>
  );
}
